<template>
    <sub-frame title="公证书">
        <div class="error">{{error}}</div>
        <div id="pdfh5"></div>
    </sub-frame>
</template>

<script>
    import PDFH5 from 'pdfh5';
    export default {
        name: "ApplyNotarization",
        data() {
          return {
              applyGuid: this.$route.query.applyGuid,
              pdfh5: '',
              error: '',
          }
        },
        mounted() {
            this.$indicator.open('加载中...');
            this.pdfh5 = new PDFH5('#pdfh5', {
                pdfurl: `${config.api_base_url}/applynotarization?applyGuid=${this.applyGuid}`,
                renderType: 'canvas',
                zoomEnable: false,
            });
            let el = document.querySelector('#pdfh5');
            el.style.visibility = 'hidden';
            this.pdfh5.on('complete', status => {
                this.$indicator.close();
                if (status !== 'success') {
                    this.$toast('公证书加载失败');
                    this.error = '公证书加载失败，请联系开发人员！';
                    return;
                }
                let imgs = document.querySelectorAll('.pdfViewer img');
                el.innerHTML = '';
                Array.from(imgs).forEach(img => {
                    img.style.width = el.clientWidth + 'px';
                    el.appendChild(img);
                });
                el.style.visibility = 'visible';
            })
        },
    }
</script>

<style scoped lang="scss">
    .error {
        margin: 15px 0 0 0;
        color: #ccc;
        text-align: center;
    }
</style>